import { createContext, useContext, useState, useEffect } from 'react';
import { adminAPI } from '@/lib/api';

const BranchFilterContext = createContext({ branch: '', setBranch: () => {}, branches: [] });

export function BranchFilterProvider({ children }) {
  const [branch, setBranchState] = useState(() => localStorage.getItem('admin_branch_filter') || '');
  const [branches, setBranches] = useState([]);

  useEffect(() => {
    adminAPI.getBranches().then(res => setBranches(res.data || [])).catch(() => {});
  }, []);

  const setBranch = (val) => {
    setBranchState(val);
    if (val) localStorage.setItem('admin_branch_filter', val);
    else localStorage.removeItem('admin_branch_filter');
  };

  return (
    <BranchFilterContext.Provider value={{ branch, setBranch, branches }}>
      {children}
    </BranchFilterContext.Provider>
  );
}

export function useBranchFilter() {
  return useContext(BranchFilterContext);
}
